var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$vuetify.breakpoint.smAndDown),expression:"!$vuetify.breakpoint.smAndDown"}],staticClass:"ml-4",attrs:{"color":"primary","fab":"","x-small":"","loading":_vm.loading},on:{"click":_vm.downloadCSV}},[_c('v-icon',[_vm._v("mdi-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }